import React, { useState } from 'react'
import { Button } from '@material-ui/core'
import { Download as DownloadIcon } from 'react-feather'

import useSnackbar from 'hooks/useSnackbar'
import * as service from 'service'

const DownloadStatement = ({
  governanceProjectActivity,
  governanceProjectId,
}) => {
  const [loading, setLoading] = useState(false)
  const snackbar = useSnackbar()

  const handleDownload = async () => {
    setLoading(true)
    try {
      const response =
        await service.dponet.governanceProjectActivity.generateSoaFile({
          governanceProjectId,
          id: governanceProjectActivity?.id,
        })

      const url = response.data.url

      window.open(url, '_blank')

      snackbar.open({
        message: 'Declaração de aplicabilidade gerada com sucesso',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message: 'Erro ao gerar declaração de aplicabilidade',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button
      startIcon={<DownloadIcon size={16} />}
      onClick={handleDownload}
      disabled={loading}
    >
      {loading ? 'Baixando...' : 'Baixar declaração '}
    </Button>
  )
}

export default DownloadStatement
